export default __webpack_public_path__ + "media/zurb/img/ecommerce/loyalty_1-9e6a263738f3a9f62da87a9811f34ef6.png";